import { render, staticRenderFns } from "./Portfolio.html?vue&type=template&id=3767d110&scoped=true&"
import script from "./Portfolio.js?vue&type=script&lang=js&"
export * from "./Portfolio.js?vue&type=script&lang=js&"
import style0 from "./Portfolio.scss?vue&type=style&index=0&id=3767d110&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3767d110",
  null
  
)

export default component.exports